import * as React from 'react';
import config from '@/server/config';

class purchaseSend extends React.Component <{}, any> {
  constructor(props: any) {
    super(props);
    this.state = {
        dataList: [],
    };
  }

  public componentDidMount() {
    this._getFooter();
  }

  render() {
    return (
      <div style={{height: '100%', background: '#f5f5f5'}}>
        <div className="buy-gqzx">
          <div className="wenbenkuang">
            <textarea maxLength={2000} rows={6} placeholder="写下您的真实需求，包括品种、规格等信息" id="content" name="content"></textarea>
          </div>
          <div className="pom">
           <input id="mobile" className="search-input" type="text" name="mobile" placeholder="请输入手机号码" maxLength={11} value="" />
            <button className="search-btn btn"  id="publish_btn_id">发布求购</button>
          </div>
          <a href="tel:4009300360" className="kefu">一键客服：4009-300-360</a>
        </div>
        <div className="footer-padding"></div>
        <div id="footer"></div>
      </div>
    );
  }
  private async _getFooter() {

    const r: any = await fetch(`${config.API2}/foot.htm?menuId=fcg`, {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
    })
    .then((res) => {
      return  res.blob()
     
    } )
    .then(data => {
      const footer = document.getElementById('footer') as any;
      var reader = new FileReader();
        reader.onload = function(e) {
          var text = reader.result;

          footer.innerHTML = text;
        }
        reader.readAsText(data, 'utf-8') 
    })
    
    return r
  }
}

export default purchaseSend;
